import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LegalPage } from "@/components/landing/LegalPage";
import { IMPRESSUM, DATENSCHUTZ } from "@/data/legal";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/landing/SmoothScroll";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Problems } from "@/components/landing/Problems";
import { BeforeAfter } from "@/components/landing/BeforeAfter";
import { Bento } from "@/components/landing/Bento";
import { Calculator } from "@/components/landing/Calculator";
import { Funnel } from "@/components/landing/Funnel";
import { Story } from "@/components/landing/Story";
import { Company } from "@/components/landing/Company";
import { Process } from "@/components/landing/Process";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import { MobileCta } from "@/components/landing/MobileCta";

const Landing = () => (
  <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Problems />
        <BeforeAfter />
        <Bento />
        <Calculator />
        <Funnel />
        <Story />
        <Company />
        <Process />
        <Faq />
      </main>
      <Footer />
      <MobileCta />
  </>
);

function App() {
  return (
    <div className="App grain" data-testid="landing-page">
      <SmoothScroll />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/impressum" element={<LegalPage doc={IMPRESSUM} testId="impressum-page" />} />
          <Route path="/datenschutz" element={<LegalPage doc={DATENSCHUTZ} testId="datenschutz-page" />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
